import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { debounce } from 'lodash';
import UserTable from '../../components/UserTable';
import TagsInput from '../../components/TagsInput';
import { API_ENDPOINTS } from '../../constants';
import api from '../../../common/services/api';
import Paginator from '../../components/Paginator';
import Spinner from '../../components/Spinner';

const TableOverflowContainer = styled.div`
  overflow: auto;
`;

function UserTableContainer({
  url, type, users: stateUsers = [], canUnfollow,
}) {
  const [isLoading, setIsLoading] = useState(true);
  const [users, setUsers] = useState(stateUsers);
  const [tags, setTags] = useState([]);
  const [searchQuery, setSearchQuery] = useState(undefined);
  const [page, setPage] = useState(1);
  const [perPage] = useState(10);
  const [lastPage, setLastPage] = useState(1);

  useEffect(() => {
    let mounted = true;
    setIsLoading(true);
    api
      .get(url, {
        params: {
          filter_tags: tags,
          filter_query: searchQuery,
          page,
          perPage,
        },
      })
      .then((response) => {
        if (!mounted) {
          return;
        }
        setUsers(response.data.data);
        setLastPage(response.data.pageInfo.lastPage);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(error);
      });

    return () => {
      mounted = false;
    };
  }, [page, perPage, searchQuery, tags, url]);

  const resetPage = () => {
    setPage(1);
  };

  const handleSearchQueryChange = useCallback(
    debounce((value) => {
      setSearchQuery(value);
      resetPage();
    }, 500),
    [],
  );

  const handleTagsChange = (newTags) => {
    setTags(newTags);
    resetPage();
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <>
      <div className="form-group">
        <label htmlFor="user-table-tags-input">Zoek op tag:</label>
        <TagsInput id="user-table-tags-input" suggestionsEndpoint={API_ENDPOINTS.tagSearch} onChange={handleTagsChange} value={tags} />
      </div>
      <div className="form-group">
        <label htmlFor="user-table-search-query-input">Zoek op naam:</label>
        <input type="text" className="form-control" id="user-table-search-query-input" onChange={event => handleSearchQueryChange(event.target.value)} />
      </div>
      {isLoading && <Spinner /> }
      {!isLoading && users.length > 0 && (
      <>
        <TableOverflowContainer>
          <UserTable
            url={url}
            users={users}
            type={type}
            actions={canUnfollow ? user => (<button className="btn btn-danger ml-2" type="submit" name="code" value={user.code}>Verwijderen</button>) : () => {}}
          />
        </TableOverflowContainer>
        <Paginator
          url={url}
          currentPage={page}
          totalItems={users.length}
          totalPages={lastPage}
          handlePageChange={handlePageChange}
        />
      </>
      )}

    </>
  );
}

export default UserTableContainer;
